export default __webpack_public_path__ + "static/media/googleplaystore.11ee92b9.svg";